import { render } from "./FormRole.vue?vue&type=template&id=76b86674&scoped=true"
import script from "./FormRole.vue?vue&type=script&lang=js"
export * from "./FormRole.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./FormRole.vue?vue&type=style&index=1&id=76b86674&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b86674"]])

export default __exports__